var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"touch",rawName:"v-touch:tap",arg:"tap"}],tag:"button",staticClass:"p-button-main",class:[
    ("p-button-main--" + _vm.kind),
    ("-" + _vm.iconColor),
    { '-disabled': _vm.disabled },
    { '-gray-out': _vm.grayOut }
  ],style:({ width: _vm.autoWidth ? '100%' : '' }),attrs:{"disabled":_vm.disabled},on:{"click":_vm.emitClickEvent}},[_c(_vm.childTag,{tag:"span",staticClass:"p-button-main__icon"},[_vm._t("icon")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }